<article
  *ngIf="visibleAlerts.length > 0"
  class="mt-5 w-full rounded-2xl border border-gray-300 bg-white/95 backdrop-blur">

  <!-- HEADER -->
  <div class="border-b border-gray-300 px-4 py-3">
    <div class="flex items-center justify-between">

      <div>
        <p class="text-[10px] font-semibold uppercase tracking-wide text-gray-400">
          Monitoring
        </p>

        <h3 class="text-sm font-semibold text-gray-900 tracking-tight">
          {{ title }}
        </h3>
      </div>

      <div class="flex items-center justify-center h-8 min-w-[32px] px-2 rounded-xl border border-gray-300 bg-white text-xs font-semibold text-gray-700">
        {{ visibleAlerts.length }}
      </div>

    </div>
  </div>

  <!-- ALERTS -->
  <div class="p-3 flex flex-col gap-3">

    <div
      *ngFor="let a of visibleAlerts; trackBy: trackByAlertId"
      class="group flex gap-3 rounded-xl border border-gray-300 bg-white p-2 transition hover:-translate-y-0.5 hover:border-gray-400 cursor-pointer"
      (click)="onViewAlert(a)">

      <!-- IMAGE -->
      <div class="w-24 h-16 overflow-hidden rounded-md bg-gray-100 flex-shrink-0">
        <img
          class="w-full h-full object-cover"
          [src]="a.rss_img_url || naPlaceholder"
          (error)="onMainImgError($event)" />
      </div>

      <!-- CONTENT -->
      <div class="flex flex-col min-w-0 flex-1">

        <span class="text-[10px] uppercase tracking-wide text-gray-400 truncate">
          {{ a.Domain || '—' }}
        </span>

        <div
          class="text-[13px] font-medium text-gray-900 leading-snug line-clamp-2 group-hover:text-blue-700 transition"
          [matTooltip]="a.rss_title">
          {{ a.rss_title || '—' }}
        </div>

        <!-- ALERT TYPE -->
        <div
          *ngIf="a.alert_type"
          class="mt-1 text-[11px] font-semibold"
          [ngClass]="alertTextClass(a.alert_type)">

          <span class="mr-1">
            {{ alertIcon(a.alert_type) }}
          </span>

          {{ a.alert_type }}

          <span
            *ngIf="a.alert_text"
            class="ml-1 text-gray-500 font-normal">
            {{ a.alert_text }}
          </span>
        </div>

        <div class="flex items-center gap-2 mt-1 flex-wrap">

          <span
            *ngIf="a.platform as plat"
            class="text-[10px] px-2 py-0.5 rounded-full border border-gray-300 bg-gray-50 font-semibold"
            [ngClass]="platformTextClass(plat)">
            {{ plat }}
          </span>

          <button
            type="button"
            class="text-[10px] font-semibold px-2 py-0.5 rounded-full border border-gray-300 bg-white hover:bg-gray-50 transition"
            (click)="onViewAlert(a); $event.stopPropagation()">
            View
          </button>

        </div>

      </div>

    </div>

  </div>

</article>